enum PaymentMode {
  creditCard = 'CREDITCARD',
  bankSlip = 'BOLETO',
  debitCard = 'DEBITCARD',
  pix = 'PIX',
  oxxo = 'OXXO',
  paynet = 'PAYNET',
  tiendasYFarmacias = 'TIENDAS_Y_FARMACIAS',
  spei = 'SPEI',
  paycash = 'PAYCASH',
  picpay = 'PICPAY',
  bankTransfer = 'BANK_TRANSFER',
  pagoEfectivo = 'PAGO_EFECTIVO',
  deuna = 'DEUNA',
  nequi = 'NEQUI',
  mach = 'MACH',
  qrInteroperable = 'QR_INTEROPERABLE',
  breb = 'BREB',
}

export default PaymentMode
